// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ngw-feature-attachment-carousel-modal > .ant-modal-mask {
  backdrop-filter: blur(4px);
  background-color: rgba(0, 0, 0, 0.95);
}
.ngw-feature-attachment-carousel-modal > .ant-modal-wrap > .ant-modal {
  margin: 0;
  inset: 0;
  padding: 0;
  max-width: unset;
  height: 100%;
}
.ngw-feature-attachment-carousel-modal > .ant-modal-wrap > .ant-modal > div[tabIndex="-1"] {
  height: 100%;
}
.ngw-feature-attachment-carousel-modal > .ant-modal-wrap > .ant-modal > div[tabIndex="-1"] > .ant-modal-content {
  box-shadow: none;
  background-color: transparent;
  padding: 0;
  height: 100%;
  overflow: hidden;
  pointer-events: none;
}
.ngw-feature-attachment-carousel-modal > .ant-modal-wrap > .ant-modal > div[tabIndex="-1"] > .ant-modal-content > .ant-modal-close {
  top: 8px;
  right: 8px;
  border-radius: 100%;
  background: none;
  width: 32px;
  height: 32px;
  pointer-events: auto;
}
.ngw-feature-attachment-carousel-modal > .ant-modal-wrap > .ant-modal > div[tabIndex="-1"] > .ant-modal-content > .ant-modal-close > .ant-modal-close-x {
  color: rgba(255, 255, 255, 0.25);
  font-size: 32px;
}
.ngw-feature-attachment-carousel-modal > .ant-modal-wrap > .ant-modal > div[tabIndex="-1"] > .ant-modal-content > .ant-modal-close > .ant-modal-close-x:hover {
  color: white;
}
.ngw-feature-attachment-carousel-modal > .ant-modal-wrap > .ant-modal > div[tabIndex="-1"] > .ant-modal-content > .ant-modal-body {
  display: flex;
  flex-direction: column;
  height: 100%;
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./package/nextgisweb/nextgisweb/feature_attachment/nodepkg/image-thumbnail/component/CarouselModal.less"],"names":[],"mappings":"AAAA;EAEQ,0BAAA;EACA,qCAAA;AAAR;AAHA;EAOQ,SAAA;EACA,QAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;AADR;AAVA;EAcY,YAAA;AADZ;AAbA;EAiBgB,gBAAA;EACA,6BAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,oBAAA;AADhB;AArBA;EAyBoB,QAAA;EACA,UAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;AADpB;AA9BA;EAkCwB,gCAAA;EACA,eAAA;AADxB;AAGwB;EACI,YAAA;AAD5B;AArCA;EA4CoB,aAAA;EACA,sBAAA;EACA,YAAA;EACA,oBAAA;AAJpB","sourcesContent":[".ngw-feature-attachment-carousel-modal {\n    > .ant-modal-mask {\n        backdrop-filter: blur(4px);\n        background-color: rgba(0, 0, 0, 0.95);\n    }\n\n    > .ant-modal-wrap > .ant-modal {\n        margin: 0;\n        inset: 0;\n        padding: 0;\n        max-width: unset;\n        height: 100%;\n\n        > div[tabIndex=\"-1\"] {\n            height: 100%;\n\n            > .ant-modal-content {\n                box-shadow: none;\n                background-color: transparent;\n                padding: 0;\n                height: 100%;\n                overflow: hidden;\n                pointer-events: none;\n\n                > .ant-modal-close {\n                    top: 8px;\n                    right: 8px;\n                    border-radius: 100%;\n                    background: none;\n                    width: 32px;\n                    height: 32px;\n                    pointer-events: auto;\n\n                    > .ant-modal-close-x {\n                        color: rgba(255, 255, 255, 0.25);\n                        font-size: 32px;\n\n                        &:hover {\n                            color: white;\n                        }\n                    }\n                }\n\n                > .ant-modal-body {\n                    display: flex;\n                    flex-direction: column;\n                    height: 100%;\n                    pointer-events: none;\n                }\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
